import {
  Notification,
  Tab
} from '@scuf/common';
import i18next from 'i18next';
import { useEffect, useState } from 'react';
import { consumeAPIs, IAPIPackage } from '../../../commonUtils/APIContext';
import { SplitPanelUtil } from '../../../commonUtils/SplitPanelUtil';
import {
  ISubscriptionBundleData,
  ISubscriptionList,
  IToastNotification,
  NEW_SUBSCRIPTION_NOTIFICATION_PRIOR_DAYS
} from './SKUModels';
import useFetch, { IUseFetch } from '../../../commonUtils/useFetch';
import authService from '../../../../authService';
import './SKUList-theme.scss';
import { IPermission } from '../../onboardingModels';
import PartnerModal from '../PartnerModal';
import FilterPopup, {
  IColumn
} from '../../../../components/FilterPopup/FilterPopup';
import { SKUColumnList } from './SKUConfig';
import { useDispatch, useSelector } from 'react-redux';
import { IOrganisationState, setSelectedOrganisation } from '../../../commonUtils/Redux/Global/globalShared';
import FilterSubscriptionList from './FilterSubscriptionList';

export const dateFormat = 'DD/MM/YYYY hh:mm A';

interface ISubscriptionListProps extends IAPIPackage { }

const SubscriptionList = (props: ISubscriptionListProps) => {
  const [subscriptionList, setSubscriptionList] = useState<ISubscriptionList[]>(
    []
  );
  const [
    pendingRenewalsubscriptionList,
    setPendingRenewalSubscriptionList
  ] = useState<ISubscriptionList[]>([]);

  const [selectedRow, setSelectedRow] = useState<ISubscriptionList>();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [toastNotification, setToastNotification] = useState<
    IToastNotification[]
  >([]);

  const organisationSelected = useSelector(
    (state: IOrganisationState) => state.globalShared.selectedOrganisation
  );

  const [filteredColumns, setFilteredColumns] = useState<IColumn[]>(
    SKUColumnList.getDefaultColumns()
  );
  const [editSKUPermission, setEditSKUPermission] = useState<boolean>(false);
  const [newSKUNotificationsShown, setNewSKUNotificationsShown] = useState<
    { [key: string]: boolean }
  >({});
  const bundleData = useSelector(
    (state: IOrganisationState) => state.globalShared.bundleList
  );
  const isLoadingBundleData = useSelector(
    (state: IOrganisationState) => state.globalShared.bundleListLoading
  );
  const isLoadingOrganisationData = useSelector(
    (state: IOrganisationState) => state.globalShared.organisationListLoading
  );

  const organisationList = useSelector(
    (state: IOrganisationState) => state.globalShared.organisationList
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      organisationList &&
      organisationList &&
      organisationList.length > 0
    ) {
      if (organisationSelected === null) {
        // Set org to the first and only entry if only 1
        dispatch(
          setSelectedOrganisation(
            organisationList.find(item => item.zuoraAccountNo !== null)
          )
        );
      }
    }

  }, [organisationList])


  const [
    skuData,
    isLoadingSKUData,
    errorSKUData,
    fetchSKUData
  ]: IUseFetch<ISubscriptionList[]> = useFetch(
    `${props.baseURL}/api/v1/subscriptions/orgs/${organisationSelected ? organisationSelected.id : ''
    }/bundles`,
    authService.authFetch,
    undefined,
    true
  );

  const [
    permissions,
    isLoadingPermissions,
    errorPermissions,
    fetchPermissions
  ]: IUseFetch<IPermission[]> = useFetch(
    authService.getSubscriptionPermFetchURL(
      organisationSelected ? organisationSelected.id : undefined
    ),
    props.authFetch,
    undefined,
    true
  );

  const updateSKUBundleDetail = (
    skuList: ISubscriptionList[],
    bundleList: ISubscriptionBundleData[]
  ) => {
    if (skuList.length && bundleList && bundleList.length) {
      const bundleMap: { [key: string]: ISubscriptionBundleData } = {};
      bundleData.forEach(item => {
        bundleMap[item.name] = item;
      });
      skuList.forEach(item => {
        if (bundleMap[item.skuName]) {
          item.bundleDetail = bundleMap[item.skuName].id;
          item.isAddOn = bundleMap[item.skuName].isAddOn;
          item.skuDescription = bundleMap[item.skuName].desc;
        }
      });
    }
  };

  useEffect(() => {
    if (skuData && Array.isArray(skuData)) {
      updateSKUList();
    }
  }, [skuData]);

  useEffect(() => {
    if (errorSKUData) {
      updateSKUList();
    }
  }, [errorSKUData]);

  useEffect(() => {
    if (organisationSelected) {
      setSubscriptionList([]);
      setPendingRenewalSubscriptionList([]);
      setSelectedRow(undefined)
      fetchSKUData();
      fetchPermissions();
    }
  }, [organisationSelected]);

  useEffect(() => {
    if (permissions) {
      hasEdtSKUPermissions();
    }
  }, [permissions]);

  useEffect(() => {
    updateSKUBundleDetail(subscriptionList, bundleData);
    if (selectedRow) {
      const subscriptionItem = subscriptionList.find(item => (item.orderNumber + item.subscriptionNumber + item.skuName) === (selectedRow.orderNumber + selectedRow.subscriptionNumber + selectedRow.skuName));
      if (subscriptionItem) {
        setSelectedRow(subscriptionItem);
      }
    }
  }, [subscriptionList, bundleData]);

  const updateSKUList = () => {
    const newSKUDate = new Date();
    newSKUDate.setDate(
      newSKUDate.getDate() - NEW_SUBSCRIPTION_NOTIFICATION_PRIOR_DAYS
    );
    const notificationData: {
      content: string;
      id: number;
    }[] = [];
    let NEW_SUBSCRIPTION_NOTIFICATION = JSON.parse(sessionStorage.getItem('NEW_SUBSCRIPTION_NOTIFICATION') || '[]');
    const updatedSubscriptionList = skuData
      ? skuData.map(item => {
        if (
          item.utilizedQuantity === 0 &&
          new Date(item.orderDate).getTime() > newSKUDate.getTime() &&
          !NEW_SUBSCRIPTION_NOTIFICATION.includes(JSON.stringify(organisationSelected.id))
        ) {
          notificationData.push({
            content: `${item.totalQuantity} ${i18next.t('licensesOf')} ${item.skuName
              }`,
            id: item.id
          });
        }
        return {
          ...item,
          bundleDetail: null
        };
      })
      : [];
    if (!NEW_SUBSCRIPTION_NOTIFICATION.includes(JSON.stringify(organisationSelected.id))) {
      NEW_SUBSCRIPTION_NOTIFICATION.push(JSON.stringify(organisationSelected.id));
      sessionStorage.setItem('NEW_SUBSCRIPTION_NOTIFICATION', JSON.stringify(NEW_SUBSCRIPTION_NOTIFICATION));
    }
    if (!newSKUNotificationsShown[organisationSelected.id]) {
      setToastNotification(notificationData);
      setNewSKUNotificationsShown({ ...newSKUNotificationsShown, ...{ [organisationSelected.id]: true } })
    }
    setSubscriptionList(updatedSubscriptionList);
    setPendingRenewalSubscriptionList(
      updatedSubscriptionList.filter(
        item => new Date(item.validTill).getTime() < new Date().getTime()
      )
    );
    updateSKUBundleDetail(updatedSubscriptionList, bundleData);
  };

  const onCloseToastNotification = (id: number) => {
    setToastNotification(toastNotification.filter(item => item.id !== id));
  };

  const manageSKUSites = (id: number) => {
    const subscriptionItem = subscriptionList.find(item => item.id === id);
    if (subscriptionItem) {
      setSelectedRow(subscriptionItem);
      onCloseToastNotification(id);
    }
  };

  const hasEdtSKUPermissions = () => {
    let hasPermission = !!authService.hasPermission(
      permissions,
      'SubscriptionManagement_SKU_Pick'
    );
    setEditSKUPermission(hasPermission);
  };

  return (
    <>
      <div className="page-header-bar">
        <div className="page-header-bar-heading">
          {i18next.t('subscriptionManagement')}
        </div>
      </div>
      <div className="sku-list-view-content page-content-container with-header sku-page-list">
        <div className="subscription-heading">
          <Tab defaultActiveIndex={0} onTabChange={setSelectedTab}>
            <Tab.Pane
              title={
                (isLoadingBundleData || isLoadingSKUData
                  ? ''
                  : subscriptionList.length) +
                '\n ' +
                i18next.t('all')
              }
            />
            <Tab.Pane
              title={
                (isLoadingBundleData || isLoadingSKUData
                  ? ''
                  : pendingRenewalsubscriptionList.length) +
                '\n ' +
                i18next.t('pendingRenewal')
              }
            />
          </Tab>
          <FilterPopup
            key={'column-filter'}
            screenSize={3}
            isFilterActive={filteredColumns.length ? true : false}
            tableColumnData={SKUColumnList}
            defaultColumnIncluded={false}
            allowedColumnCount={[6, 6, 6]}
            onFilterClick={columns => {
              setFilteredColumns(columns);
            }}
          />
        </div>
        <SplitPanelUtil>
          <SplitPanelUtil.Table>
            {selectedTab === 0 && (
              <FilterSubscriptionList
                subscriptionList={subscriptionList}
                isLoading={
                  isLoadingBundleData ||
                  isLoadingSKUData ||
                  isLoadingOrganisationData ||
                  isLoadingPermissions
                }
                editSKUPermission={editSKUPermission}
                filteredColumns={filteredColumns}
                setSelectedRow={setSelectedRow}
              />)
            }
            {selectedTab === 1 && (
              <FilterSubscriptionList
                subscriptionList={pendingRenewalsubscriptionList}
                isLoading={
                  isLoadingBundleData ||
                  isLoadingSKUData ||
                  isLoadingOrganisationData ||
                  isLoadingPermissions
                }
                editSKUPermission={editSKUPermission}
                filteredColumns={filteredColumns}
                setSelectedRow={setSelectedRow}
              />)
            }
            {selectedRow && (
              <PartnerModal
                key={'manageSKU'}
                isLoading={isLoadingSKUData}
                onClose={() => {
                  setSelectedRow(undefined);
                }}
                onSave={() => {
                  fetchSKUData();
                }}
                panelSelectedRow={selectedRow}
              />
            )}
          </SplitPanelUtil.Table>
        </SplitPanelUtil>
      </div>

      <div className="sku-notification-container">
        {toastNotification.map((item, index) => (
          <Notification
            key={index}
            title={i18next.t('newSubscriptionAdded')}
            hasIcon={true}
            onCloseClick={() => onCloseToastNotification(item.id)}
            detailsText={i18next.t('manageSites')}
            onDetailsClick={() => manageSKUSites(item.id)}
            severity="information"
          >
            {item.content}
          </Notification>
        ))}
      </div>
    </>
  );
};

export default consumeAPIs(SubscriptionList);
